import { StakingErc3643RewardTokenRow } from 'Modules'
import { useCallback, useEffect, useState } from 'react'

import { stakingErc3643Api } from 'api/staking-erc3643-api'
import { logError } from 'utils/logger'

export const useStakingErc3643RewardTokens = () => {
  const [rewardTokens, setRewardTokens] = useState<StakingErc3643RewardTokenRow[]>([])
  const [loading, setLoading] = useState(false)

  const loadRewardTokens = useCallback(async () => {
    setLoading(true)
    try {
      const res = await stakingErc3643Api.getRewardTokens({ limit: 50, page: 1 })
      if (res.data?.success) {
        setRewardTokens(res.data.data?.results ?? [])
      }
    } catch (error) {
      logError('Load reward tokens failed', error)
      setRewardTokens([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void loadRewardTokens()
  }, [loadRewardTokens])

  return { rewardTokens, loadRewardTokens, loadingRewardTokens: loading }
}
